// Duits (de-DE), ridesApp: zelfde vorm als ridesApp.nl.ts. "Bringen und holen" is gewoon Duits
// voor brengen en halen; het werkwoord `holt` (niet het scheidbare "holt ab") past in "Wer holt
// am …?" en "Anne holt diesmal". Wat ontbreekt valt terug op het Nederlands.
export const appRidesDe = {
    unknown: 'Noch unklar',
    notNeeded: 'Nicht nötig',
    perDay: 'Je nach Tag anders',
    perDayHint: 'Zum Beispiel montags {a} und donnerstags {b}.',
    perDayHintOne: 'Zum Beispiel montags jemand anderes als donnerstags.',
    sameEveryDay: 'Jedes Mal dieselbe Person',
    day: 'Tag',
    roleOnDay: '{role} am {day}',
    change: 'Ändern',
    close: 'Fertig',
    droppedDays: {
        one: 'Wer am {days} fährt, entfällt: Dieser Tag gehört nicht mehr zur Wiederholung.',
        other: 'Wer am {days} fährt, entfällt: Diese Tage gehören nicht mehr zur Wiederholung.',
    },
    cantDrive: 'Geht nicht? Jemand anderes',
    iCant: 'Ich kann nicht, offen lassen',
    someoneElse: 'Jemand anderes fährt',
    whoInstead: 'Wer {role} am {date}?',
    whoInsteadHint: 'Nur dieses Mal. Die anderen Male bleiben, wie sie sind.',
    onlyThisTime: 'Nur dieses Mal',
    usually: 'sonst {name}',
    usuallyNobody: 'sonst noch niemand',
    everyWeekday: 'jeden {day}',
    backToUsual: 'Zurück zu normal',
    takenOver: '{name} {role} diesmal',
    nobodyNow: '{role} steht diesmal auf „Wer fährt?“. Die anderen sehen es.',
    backDone: '{role} wieder wie sonst',
    verbDropoff: 'bringt',
    verbPickup: 'holt',
};
//# sourceMappingURL=ridesApp.de.js.map